import { ApiService } from "@/api";

export const getSampleGroupDetailLeader = (groupId: string) => {
  return ApiService.baseAction(`/sample-group/${groupId}/detail`, {}, 'get');
}